export default __webpack_public_path__ + "static/media/not-found.95712b58.svg";